import { InputGroup, Form, Button } from 'react-bootstrap';
import { PlusCircle, DashCircle } from 'react-bootstrap-icons';

interface InputSpaceProps {
    content: string;
    onPlusClick: () => void;
    onMinusClick: () => void;
}

export function InputSpace(props: InputSpaceProps){
    return (
        <span className="text-input">
                <InputGroup>
                <InputGroup.Prepend>
                    <Button 
                        variant="outline-secondary" 
                        onClick={ props.onPlusClick }
                    >
                        <PlusCircle />
                    </Button>
                </InputGroup.Prepend>
                <Form.Control defaultValue={ props.content } />
                <InputGroup.Append>
                    <Button 
                        variant="outline-secondary" 
                        onClick={ props.onMinusClick }
                    >
                        <DashCircle />
                    </Button>
                </InputGroup.Append>
            </InputGroup>
        </span>
    );
}